import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import productsService from "services/ProductsServices";

export const getAllProducts = createAsyncThunk(
	"products/getAll",
	async (_, { rejectWithValue }) => {
		try {
			const response = await productsService.getAllProducts();
			return response?.data;
		} catch (error) {
			return rejectWithValue(error.response || "Erreur");
		}
	}
);

export const getOneProductForAdminSchool = createAsyncThunk(
	"products/getOneProductForAdminSchool",
	async ({ id }, { rejectWithValue }) => {
		try {
			const response = await productsService.getOneProductForAdminSchool({
				id,
			});
			return response?.data;
		} catch (error) {
			console.log(error);
			return rejectWithValue(error.response || "Erreur");
		}
	}
);

export const createProduct = createAsyncThunk(
	"products/create",
	async ({ product }, { rejectWithValue }) => {
		try {
			const response = await productsService.createProduct({ product });
			return response?.data;
		} catch (error) {
			console.log(error);
			return rejectWithValue(error.response || "Erreur");
		}
	}
);
export const updateProduct = createAsyncThunk(
	"products/update",
	async ({ product, id }, { rejectWithValue }) => {
		try {
			const response = await productsService.updateProduct({ product, id });
			return response?.data;
		} catch (error) {
			console.log(error);
			return rejectWithValue(error.response || "Erreur");
		}
	}
);
export const deleteProductById = createAsyncThunk(
	"products/deleteById",
	async ({ id }, { rejectWithValue }) => {
		try {
			const response = await productsService.deleteProductById({ id });
			return { ressponse: response?.data, id: id };
		} catch (error) {
			console.log(error);
			return rejectWithValue(error.response || "Erreur");
		}
	}
);

const initialState = {
	products: [],
	product: null,
	loading: false,
	error: null,
};

const productsSlice = createSlice({
	name: "products",
	initialState,
	reducers: {
		setProducts: (state, action) => {
			state.products = action.payload;
		},

		setProduct: (state, action) => {
			state.product = action.payload;
		},
	},
	extraReducers: {
		[getAllProducts.pending]: (state) => {
			state.loading = true;
		},
		[getAllProducts.fulfilled]: (state, { payload }) => {
			state.products = payload.data;
			state.loading = false;
		},
		[getAllProducts.rejected]: (state) => {
			state.loading = false;
		},

		[getOneProductForAdminSchool.pending]: (state) => {
			state.loading = true;
		},
		[getOneProductForAdminSchool.fulfilled]: (state, { payload }) => {
			state.product = payload.product;
			state.loading = false;
		},
		[getOneProductForAdminSchool.rejected]: (state) => {
			state.loading = false;
		},

		[createProduct.pending]: (state) => {
			state.loading = true;
		},
		[createProduct.fulfilled]: (state, { payload }) => {
			state.loading = false;
			state.products.push(payload.product);
		},
		[createProduct.rejected]: (state) => {
			state.loading = false;
		},
		[updateProduct.pending]: (state) => {
			state.loading = true;
		},
		[updateProduct.fulfilled]: (state, { payload }) => {
			const objToUpdateIndex = state.products.findIndex(
				(prod) => prod._id === payload.product._id
			);
			if (objToUpdateIndex !== -1)
				state.products[objToUpdateIndex] = payload.product;
			state.loading = false;
		},
		[updateProduct.rejected]: (state) => {
			state.loading = false;
		},
		[deleteProductById.pending]: (state) => {
			state.loading = true;
		},
		[deleteProductById.fulfilled]: (state, { payload }) => {
			const objToDelIndex = state.products.findIndex(
				(prod) => prod._id === payload
			);
			if (objToDelIndex !== -1) state.products.splice(objToDelIndex, 1);

			state.loading = false;
		},
		[deleteProductById.pending]: (state) => {
			state.loading = false;
		},
	},
});

export const { setProducts, setProduct } = productsSlice.actions;

export default productsSlice.reducer;
